import {
  AirType,
  AirMetricType,
  AnalyticsGatewayService,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { FeatureMockRouter } from '@frontend/demo-interceptors';
import { MockAPIRouter } from '@frontend/fetch';
import { mairAggregatesDummyData } from '../configs/messaging-air/aggregate-data';
import { aiConversationsDummyData } from '../configs/messaging-air/ai-conversations-data';
import { staffTransferredConversationsDummyData } from '../configs/messaging-air/staff-transferred-conversations-data';
import { vairAggregatesDummyData } from '../configs/voice-air/aggregate-data';
import { followUpTasksDummyData } from '../configs/voice-air/follow-up-tasks-data';
import { staffTransferredCallDummyData } from '../configs/voice-air/staff-transfered-calls-data';
import { AirDemoMockRouterContext } from './types';

const AGGREGATES_MOCK_DATA_MAP = {
  [AirType.MAIR]: mairAggregatesDummyData,
  [AirType.VAIR]: vairAggregatesDummyData,
};

const MOCK_DATA_MAP = {
  [AirMetricType.FOLLOW_UP_TASKS]: followUpTasksDummyData,
  [AirMetricType.STAFF_TRANSFERED_CALLS]: staffTransferredCallDummyData,
  [AirMetricType.AI_THREADS]: aiConversationsDummyData,
  [AirMetricType.STAFF_TRANSFERS]: staffTransferredConversationsDummyData,
};

export const AirMockRouter: FeatureMockRouter<AirDemoMockRouterContext> = {
  addMockRouterEndpoints: (router) => {
    // GetAirAggregates endpoint mock
    router.schemaEndpoint(AnalyticsGatewayService.GetAirAggregates, async (request, _) => {
      // Return placeholder response structure:
      const payload = await request.clone().json();
      const relevantMockData = AGGREGATES_MOCK_DATA_MAP[payload.airType as AirType];
      return MockAPIRouter.json(relevantMockData);
    });

    // GetAirData endpoint mock
    router.schemaEndpoint(AnalyticsGatewayService.GetAirData, async (request, _) => {
      // Return placeholder response structure:
      const payload = await request.clone().json();
      const relevantMockData = MOCK_DATA_MAP[payload.metricType as AirMetricType];
      return MockAPIRouter.json(relevantMockData);
    });
  },

  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries(['AnalyticsGatewayV1', 'GetAirAggregates']);
    queryClient.invalidateQueries(['AnalyticsGatewayV1', 'GetAirData']);
  },
};
